import { render, staticRenderFns } from "./AniNumbers.vue?vue&type=template&id=763f4b64&scoped=true&"
import script from "./AniNumbers.vue?vue&type=script&lang=js&"
export * from "./AniNumbers.vue?vue&type=script&lang=js&"
import style0 from "./AniNumbers.vue?vue&type=style&index=0&id=763f4b64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763f4b64",
  null
  
)

component.options.__file = "AniNumbers.vue"
export default component.exports